import keyMirror from 'utils/keyMirror';

/**
 * @constant {Object} PlaidConstants
 * @memberof Application
 */
export const PlaidConstants = keyMirror({
  PLAID_START: undefined,
  PLAID_SUCCESS: undefined,
  PLAID_EXIT: undefined,
  PLAID_UPDATE: undefined,
});
